import { render, staticRenderFns } from "./ORTSaved.vue?vue&type=template&id=787e0270&scoped=true"
import script from "./ORTSaved.vue?vue&type=script&lang=js"
export * from "./ORTSaved.vue?vue&type=script&lang=js"
import style0 from "./ORTSaved.vue?vue&type=style&index=0&id=787e0270&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787e0270",
  null
  
)

export default component.exports